import type {FavouriteRepositoryInterface} from '@/src/core/application/favourite'
import {inject, injectable} from 'inversify'
import {FetchOptionsFactoryProxyInterface} from '@/src/core/domain/page/functions/fetch/types'
import {DI} from '@/src/config/di/types'
import {Routes} from '@/src/config/routes'

@injectable()
export class FavouriteFetchOptionsFactoryProxy implements FetchOptionsFactoryProxyInterface {
  @inject(DI.FavouriteRepositoryInterface)
  favouriteRepository!: FavouriteRepositoryInterface

  create() {
    return async () => ({
      suspendUntilClientReady: typeof window === 'undefined',
      apiEndpoint: Routes.api.favourite,
      extraParams: async () => ({
        productIds: await this.favouriteRepository.getAll(),
      }),
    })
  }
}
